var matchesMethod = ( function() {
  var ElemProto = window.Element.prototype;
  // check for the standard method name first
  if ( ElemProto.matches ) {
    return 'matches';
  }
  // check un-prefixed
  if ( ElemProto.matchesSelector ) {
    return 'matchesSelector';
  }
  // check vendor prefixes
  var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

  for ( var i=0; i < prefixes.length; i++ ) {
    var prefix = prefixes[i];
    var method = prefix + 'MatchesSelector';
    if ( ElemProto[ method ] ) {
      return method;
    }
  }
})();

export default function matchesSelector( elem, selector ) {
  return elem[ matchesMethod ]( selector );
}
